var fontFamilies = {
  Montserrat: {
    font: 'Montserrat',
    fallback: 'Helvetica, Arial'
  },
  Anton: {
    font: 'Anton',
    fallback: 'Impact'
  }
};
export default (function (family) {
  var style = 'inherit';

  if (family) {
    style = "'".concat(fontFamilies[family].font, "', ").concat(fontFamilies[family].fallback, ", sans-serif");
  }

  return style;
});